// src/components/usdt.js

import axios from "axios";

/* ======================================================
   GET USDT ADDRESS
   GET /api/usdt/address
====================================================== */
export async function fetchUsdtAddress() {

  try {

    const res =
      await axios.get(

        "/api/usdt/address",

        {
          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    if (err?.response?.status === 404) {
      return null;
    }

    throw err;

  }

}

/* ======================================================
   GET USDT BALANCE
   GET /api/usdt/balance
====================================================== */

export async function fetchUsdtBalance() {

   try {

      const res =
      await axios.get(

         "/api/usdt/balance",

         {
            withCredentials:true,
         }

      );

      return res.data;

   } catch (err) {

      throw err;

   }

}

export async function fetchUsdtHistory() {

  try {

    const res =
      await axios.get(

        "/api/usdt/history",

        {
          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    throw err;

  }

}

/* ======================================================
   RECONCILE USDT BALANCE
   POST /api/usdt/reconcile
====================================================== */

export async function reconcileUsdtBalance() {

  try {

    const res =
      await axios.post(

        "/api/usdt/reconcile",

        {},

        {
          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    throw err;

  }

}
